import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { useMemo } from 'react';

const NullContentRecommendation = () => null;

export const DpSearchBanner = () => {
	const router = useNextRouter();

	const emsName = useMemo(() => {
		const { searchTerm } = router.query;
		const term = Array.isArray(searchTerm) ? searchTerm.join(' ') : (searchTerm as string);
		return `banner_regladebusquedas_${decodeURIComponent(term).replace(/\s+/g, '_').toUpperCase()}`; // banner_regladebusquedas_ADIDAS_CAMPUS
	}, [router.query]);

	return (
		<ContentRecommendation
			id={emsName}
			properties={{
				emsName,
			}}
			loadingElement={<NullContentRecommendation />}
		/>
	);
};
